import React, { useState } from "react";
import { Container } from "./styles";
import { GoChecklist, GoAlert, GoCreditCard, GoArrowSwitch, GoFileSymlinkFile } from "react-icons/go";
import { FiRefreshCw } from "react-icons/fi";
import { toast } from "react-toastify";
import PainelTab from "./components/PainelTab";
import DivergenciasTab from "./components/DivergenciasTab";
import DetalheTab from "./components/DetalheTab";
import CreditoTravadoTab from "./components/CreditoTravadoTab";
import LiquidacaoTab from "./components/LiquidacaoTab";
import DossieTab from "./components/DossieTab";
import { contexto, resumoTipos } from "./mockData";
import useValidacaoFiscalData from "./hooks/useValidacaoFiscalData";
import validacaoFiscalService from "../../services/validacaoFiscalService";

const TOTAL_DIVERGENCIAS_MOCK = resumoTipos.reduce((acc, t) => acc + t.qtde, 0);

const TABS = [
  { id: "painel", label: "Painel de Fechamento", icon: GoChecklist },
  { id: "divergencias", label: "Divergências", icon: GoAlert },
  { id: "detalhe", label: "Detalhe", icon: GoFileSymlinkFile },
  { id: "credito", label: "Crédito Travado", icon: GoCreditCard },
  { id: "liquidacao", label: "Liquidação Planejada", icon: GoArrowSwitch },
  { id: "dossie", label: "Dossiê", icon: GoFileSymlinkFile },
];

const MES_ATUAL = new Date().getMonth() + 1;
const ANO_ATUAL = new Date().getFullYear();

export default function ValidacaoFiscal() {
  const [activeTab, setActiveTab] = useState("painel");
  const [selectedDivergenciaId, setSelectedDivergenciaId] = useState(null);
  const [abrindo, setAbrindo] = useState(false);
  const [conciliando, setConciliando] = useState(false);
  const vf = useValidacaoFiscalData();
  const hasRealData = vf.mode === "real" && !!vf.competenciaId;
  const competenciaAtiva = vf.competencias.find((c) => c.id === vf.competenciaId);

  const abrirDetalhe = (id) => {
    setSelectedDivergenciaId(id);
    setActiveTab("detalhe");
  };

  const handleAbrirCompetencia = async () => {
    setAbrindo(true);
    try {
      await vf.abrirCompetencia(ANO_ATUAL, MES_ATUAL, "cbs");
      toast.success("Competência aberta.");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Erro ao abrir competência.");
    } finally {
      setAbrindo(false);
    }
  };

  const handleIniciarConciliacao = async () => {
    if (!vf.competenciaId) return;
    setConciliando(true);
    try {
      await validacaoFiscalService.iniciarConciliacao(vf.competenciaId);
      toast.success("Conciliação enfileirada — processando em segundo plano.");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Erro ao iniciar conciliação.");
    } finally {
      setConciliando(false);
    }
  };

  return (
    <Container>
      <div className="header-info">
        <div className="header-details">
          <h3>Validação Fiscal CBS/IBS</h3>
          <div className="header-meta">
            <span className="status-tag">{hasRealData ? "Base: dados reais" : "Base: dados ilustrativos"}</span>
            {hasRealData ? (
              <span className="update-tag">
                {String(competenciaAtiva?.mes).padStart(2, "0")}/{competenciaAtiva?.ano} ·{" "}
                {competenciaAtiva?.tributo?.toUpperCase()} · status: {competenciaAtiva?.status}
              </span>
            ) : (
              <span className="update-tag">
                {contexto.empresa} · CNPJ raiz {contexto.cnpjRaiz} · Competência {contexto.competencia} (exemplo)
              </span>
            )}
          </div>
        </div>
        <div className="header-actions">
          {!hasRealData && (
            <button type="button" className="icon-btn primary" onClick={handleAbrirCompetencia} disabled={abrindo}>
              {abrindo ? "Abrindo…" : `Abrir competência ${String(MES_ATUAL).padStart(2, "0")}/${ANO_ATUAL}`}
            </button>
          )}
          {hasRealData && (
            <button type="button" className="icon-btn primary" onClick={handleIniciarConciliacao} disabled={conciliando}>
              <FiRefreshCw /> {conciliando ? "Enfileirando…" : "Iniciar conciliação"}
            </button>
          )}
        </div>
      </div>

      <div className="tabs-header">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const badge = tab.id === "divergencias" && !hasRealData ? TOTAL_DIVERGENCIAS_MOCK : undefined;
          return (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon />
              {tab.label}
              {!!badge && <span className="tab-badge">{badge}</span>}
            </button>
          );
        })}
      </div>

      {activeTab === "painel" && <PainelTab competenciaId={vf.competenciaId} />}
      {activeTab === "divergencias" && (
        <DivergenciasTab competenciaId={vf.competenciaId} onAbrirDetalhe={abrirDetalhe} />
      )}
      {activeTab === "detalhe" && (
        <DetalheTab
          key={selectedDivergenciaId}
          selectedId={selectedDivergenciaId}
          competenciaId={vf.competenciaId}
          onVoltar={() => setActiveTab("divergencias")}
        />
      )}
      {activeTab === "credito" && <CreditoTravadoTab competenciaId={vf.competenciaId} />}
      {activeTab === "liquidacao" && <LiquidacaoTab competenciaId={vf.competenciaId} />}
      {activeTab === "dossie" && <DossieTab competenciaId={vf.competenciaId} />}
    </Container>
  );
}
